import {
  Dimensions,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC, useState } from 'react';
import { DatePickerProps } from './DatePicker.types';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../Image';
import dayjs from 'dayjs';
import { FONTS } from '../../constants';
import { Calendar } from '../Calendar';
import { useIsDesktop } from '../../hooks/useIsDeskTop';

const DatePicker: FC<DatePickerProps> = ({
  date,
  haveCalendar = false,
  onChangeDate,
}) => {
  const isDesktop = useIsDesktop();

  const [showCalendar, setShowCalendar] = useState<boolean>(false);
  const screenWidth = Dimensions.get('window').width;

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          zIndex: 100,
          alignItems: 'center',
        }}
      >
        <TouchableOpacity
          style={styles.arrowButton}
          onPress={() => {
            const previousDate = new Date(date);
            previousDate.setDate(previousDate.getDate() - 1);
            const previousDateString = previousDate.toISOString().split('T')[0];
            onChangeDate(previousDateString);
          }}
        >
          <Image
            source={require('../../assets/left-arrow.png')}
            style={styles.arrowStyle}
          />
        </TouchableOpacity>
        <Text
          style={{
            color: STYLE_VARS.textColor,
            fontWeight: '500',
            fontFamily: FONTS.IowanOldStyleBTRoman,
            fontSize: 16,
            lineHeight: 28,
            letterSpacing: 1,
            textTransform: 'uppercase',
            paddingHorizontal: 5,
          }}
        >
          {dayjs(date).format('ddd DD MMM YYYY')}
        </Text>
        <TouchableOpacity
          style={styles.arrowButton}
          onPress={() => {
            const nextDate = new Date(date);
            nextDate.setDate(nextDate.getDate() + 1);
            const nextDateString = nextDate.toISOString().split('T')[0];
            onChangeDate(nextDateString);
          }}
        >
          <Image
            source={require('../../assets/right-arrow.png')}
            style={styles.arrowStyle}
          />
        </TouchableOpacity>
        {haveCalendar && (
          <>
            <TouchableOpacity
              style={styles.arrowButton}
              onPress={setShowCalendar.bind(null, !showCalendar)}
            >
              <Image
                source={require('../../assets/bookings-white.png')}
                style={{
                  marginLeft: 5,
                  width: 22,
                  height: 22,
                  resizeMode: 'contain',
                  tintColor: STYLE_VARS.primaryColor,
                }}
              />
            </TouchableOpacity>
          </>
        )}
      </View>
      {showCalendar && (
        <View
          style={{
            zIndex: 100,
            width: 300,
            position: 'absolute',
            backgroundColor: '#EEEEEE',
            right: isDesktop() ? 300 : (screenWidth - 300) / 2,
            top: 40,
          }}
        >
          <Calendar
            onChangeDate={onChangeDate}
            initDate={date}
            setShowCalendar={setShowCalendar}
            showCalendar={showCalendar}
          />
        </View>
      )}
    </>
  );
};

export default DatePicker;

const styles = StyleSheet.create({
  arrowButton: {
    padding: 3,
  },
  arrowStyle: {
    height: 13,
    width: 10,
    resizeMode: 'contain',
    tintColor: STYLE_VARS.primaryColor,
  },
});
